import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import { Input, Button, Form } from 'antd';
import Wrapper from './style';
import Comment from './Comment';

const { TextArea } = Input;

class CommentList extends Component {
	state = {
		message: ''
	};

	renderList = () => {
		const { msgs, user, onDelete } = this.props;
		return msgs.map((item, index) => {
			const isCreator = user.email === item.User.email;
			return (
				<Comment
					data={item}
					isCreator={isCreator}
					key={'comment' + index}
					onDelete={() => {
						onDelete(item.id);
					}}
				/>
			);
		});
	};

	handleSubmit = (e) => {
		const { onSubmit } = this.props;
		const { message } = this.state;
		e.preventDefault();
		if (message.length === 0) return;
		onSubmit(message);
		this.setState({
			message: ''
		});
	};

	handleChangeInput = (e) => {
		const { name, value } = e.target;
		if (value.length > 125) return;
		this.setState({ [name]: value.slice(0, 125) });
	};

	render() {
		const { showMore, isLoading, user, msgs } = this.props;
		const { message } = this.state;
		const obj = {
			pathname: '/login',
			state: {
				project: window.location.pathname
			}
		};
		return (
			<Wrapper>
				{user.id === 0 ? (
					<div className="msg-alert">
						<p>
							To make a comment you must Login.{' '}
							<Link to={obj}>Login.</Link>
						</p>
					</div>
				) : (
					<Form className="msg-form" onSubmit={this.handleSubmit}>
						<TextArea
							placeholder="Input a message"
							name="message"
							value={message}
							onChange={this.handleChangeInput}
							rows={2}
						/>
						<span className="msg-length">{message.length}/125</span>
						<div className="msg-btn">
							<Button type="primary" htmlType="submit">
								Post
							</Button>
						</div>
					</Form>
				)}
				<div className="msg-list">
					{this.renderList()}
					{msgs.length >=
						10 **
						(
							<div className="mst-list-btn">
								<Button
									type="primary"
									onClick={showMore}
									loading={isLoading}
								>
									Show More
								</Button>
							</div>
						)}
				</div>
			</Wrapper>
		);
	}
}

export default CommentList;
